import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateLayout } from '../redux/dashboardSlice.js';

export const useWidgetAutoHeight = ({ widgetId, editable }) => {
  const rowHeight = useSelector(state => state.dashboard.rowHeight);
  const fullLayout = useSelector((state) => state.dashboard.layout);
  const layout = fullLayout[widgetId];
  const [targetHeight, setTargetHeight] = useState(0);
  const heightMode = useSelector((state) => state.dashboard.widgets[widgetId].settings.heightMode || 'fixed');
  const maxHeight = useSelector((state) => state.dashboard.widgets[widgetId].settings.maxHeight);
  const dispatch = useDispatch();

  const resizeWidgetItem = useCallback(() => {
    if (editable || heightMode === 'fixed' || !layout || !fullLayout || !rowHeight) {
      return;
    }

    const desiredHeight = (heightMode === 'autoWithMax' && maxHeight ? Math.min(targetHeight, maxHeight) : targetHeight);
    const newHeightInRows = Math.ceil(desiredHeight / rowHeight);
    if (newHeightInRows <= layout.h) {
      return;
    }

    const newLayout = Object.values(fullLayout).map((layoutItem) =>
      layoutItem.i === layout.i
        ? {
            ...layoutItem,
            autoResizePreviousH: layoutItem.autoResizePreviousH ?? layoutItem.h,
            h: newHeightInRows
          }
        : layoutItem,
    );

    dispatch(updateLayout(newLayout));
  }, [dispatch, editable, heightMode, maxHeight, targetHeight, layout, fullLayout, rowHeight]);

  useEffect(() => {
    resizeWidgetItem();
  }, [resizeWidgetItem]);

  return { setTargetHeight };
};
